module.exports = (__webpack_require__(0))(413);


//////////////////
// WEBPACK FOOTER
// delegated ./src/assets/Girder_Mark.png from dll-reference girder_lib
// module id = 18
// module chunks = 0